import { UrlApi } from "../../../../services/apirest";

/**
 * @param {{ nro_cuit: string, motivo?: string, setNotify: Function }} params
 */
export async function handleRechazarProveedor({ nro_cuit, motivo, setNotify }) {
    const body = {
        nro_cuit,
        usuario: localStorage.getItem("user") || undefined,
    };
    const motivoTrim = String(motivo ?? "").trim();
    if (motivoTrim) {
        body.motivo = motivoTrim;
    }

    try {
        const response = await fetch(`${UrlApi}/proveedores/rechazar`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });
        const json = await response.json().catch(() => ({}));

        if (response.ok && json.ok !== false) {
            setNotify({
                open: true,
                severity: "success",
                color: "#D4EFDF",
                mensaje: json.msg || "Proveedor rechazado correctamente",
            });
            return { ok: true, msg: json.msg };
        }

        setNotify({
            open: true,
            severity: "error",
            color: "#FADBD8",
            mensaje: json.msg || json.message || "Error al rechazar el proveedor",
        });
        return { ok: false, msg: json.msg || json.message };
    } catch (error) {
        console.error("Error al rechazar proveedor:", error);
        setNotify({
            open: true,
            severity: "error",
            color: "#FADBD8",
            mensaje: "Error al rechazar el proveedor",
        });
        return { ok: false, msg: "Error al rechazar el proveedor" };
    }
}

/**
 * Deriva el label de revisión a partir de flags o estado_revision del backend.
 * @param {{ revisado_compras?: number|string, revisado_impuestos?: number|string, estado_revision?: string, para_revisar?: number|string, rechazado?: number|string }} row
 */
export function getEstadoRevisionProveedor(row = {}) {
    if (Number(row.rechazado) === 1) {
        return { key: "rechazado", label: "Rechazado" };
    }

    const estado = row.estado_revision;
    if (estado === "aprobado") {
        return { key: "aprobado", label: "Aprobado" };
    }
    if (estado === "revisado_compras") {
        return { key: "revisado_compras", label: "Revisado por área compra" };
    }
    if (estado === "revisado_impuestos") {
        return { key: "revisado_impuestos", label: "Revisado por área impuesto" };
    }
    if (estado === "pendiente") {
        return { key: "pendiente", label: "Para revisar" };
    }

    const compras = Number(row.revisado_compras) === 1;
    const impuestos = Number(row.revisado_impuestos) === 1;

    if (compras && impuestos) {
        return { key: "aprobado", label: "Aprobado" };
    }
    if (compras && !impuestos) {
        return { key: "revisado_compras", label: "Revisado por área compra" };
    }
    if (!compras && impuestos) {
        return { key: "revisado_impuestos", label: "Revisado por área impuesto" };
    }
    if (Number(row.para_revisar) === 1) {
        return { key: "pendiente", label: "Para revisar" };
    }

    return { key: "", label: "" };
}

export async function handleguardarCambios(params) {
    console.log("Iniciando handleguardarCambios con accion:", params.accion);

    const {
        datosFormulario,
        imputacionesSeleccionadas,
        empresasSeleccionadas,
        operacionesSeleccionadas,
        accion,
        area_aprobacion,
        reqBody,
        setNotify
    } = params;

    const body = {
        datosFormulario,
        imputacionesSeleccionadas,
        empresasSeleccionadas,
        operacionesSeleccionadas,
        accion,
        reqBody
    };

    if (accion === 1 && area_aprobacion) {
        body.area_aprobacion = area_aprobacion;
    }

    try {
    const response = await fetch(UrlApi + "/proveedores/updateandpostproveedor", {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
    });
   const json = await response.json();
    console.log("respuesta backend", json);

    if (response.ok && json.ok) {
      setNotify({
        open: true,
        severity: "success",
        color: "#D4EFDF",
        mensaje: json.msg || "Guardado"
      });
      return {
        ok: true,
        msg: json.msg,
        estado_revision: json.estado_revision,
        revisado_compras: json.revisado_compras,
        revisado_impuestos: json.revisado_impuestos,
      };
    } else {
      setNotify({
        open: true,
        severity: "error",
        color: "#FADBD8",
        mensaje: json.msg || "Error al guardar"
      });
      return { ok: false, msg: json.msg };
    }
  } catch (error) {
    console.error("Error:", error);
    setNotify({
      open: true,
      severity: "error",
      color: "#FADBD8",
      mensaje: "Error al guardar"
    });
    return { ok: false, msg: "Error al guardar" };
  }
}


        // try {
        //     const response = await fetch(UrlApi + "/proveedores/updateandpostproveedor", {
        //         method: "POST",
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //         body: JSON.stringify({
        //             accion,
        //             datosFormulario,

        //             imputaciones: (imputacionesSeleccionadas || []).map(imp => ({
        //                 idimputacion: imp.idimputacion,
        //                 nro_cuit: datosFormulario.nro_cuit,
        //                 usuario: localStorage.getItem("user")
        //             })),

        //             empresas: (empresasSeleccionadas || []).map(id_empresa => ({
        //                 id_empresa,
        //                 nro_cuit: datosFormulario.nro_cuit,
        //                 usuario: localStorage.getItem("user")
        //             })),

        //             operaciones: (operacionesSeleccionadas || []).map(op => ({
        //                 id_operacion: op.id_operacion || op.idoperacion,
        //                 nro_cuit: datosFormulario.nro_cuit,
        //                 usuario: localStorage.getItem("user"),
        //                 operacion_otros: op.operacion_otros
        //             })),

        //              ...reqBody   


        //         }),
        //     });

        //     const data = await response.json();

        //     if (!response.ok) {
        //         console.error("Error del servidor:", data);
        //         return data;
        //     }

        //     return data;

        // } catch (error) {
        //     console.error("Error en el fetch:", error);
        //     return { ok: false, msg: "Error de conexión con el servidor" };
        // }


// export async function handleguardarCambios(params) {
//     console.log("entro a la funcion");

//     const { datosFormulario, imputacionesSeleccionadas, empresasSeleccionadas, accion} = params;

//     try {
//         const response = await fetch(UrlApi + "/proveedores/updateandpostproveedor", {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//                 datosFormulario: datosFormulario,

//                 imputaciones: imputacionesSeleccionadas.map(imp => ({
//                     id_imputacion: imp.idimputacion,
//                     nro_cuit: datosFormulario.nro_cuit,
//                     usuario: localStorage.getItem("user")
//                 })),

//                 empresas: empresasSeleccionadas.map(id_empresa => ({
//                     id_empresa,
//                     nro_cuit: datosFormulario.nro_cuit,
//                     usuario: localStorage.getItem("user")
//                 }))
//             }),
//         });

//         const data = await response.json();

//         if (!response.ok) {
//             console.error("Error del servidor:", data);
//             alert("Hubo un error guardando el proveedor.");
//             return;
//         }

//         alert("Cambios guardados correctamente ✔");
//         return data;

//     } catch (error) {
//         console.error("Error en el fetch:", error);
//         alert("Error de conexión con el servidor.");
//     }
// };

// export async function handleguardarCambios(params) {
//     console.log("Iniciando handleguardarCambios con accion:", params.accion);

//     const {
//         datosFormulario,
//         imputacionesSeleccionadas,
//         empresasSeleccionadas,
//         operacionesSeleccionadas, // Agregado para soportar edición de operaciones
//         accion
//     } = params;

//     try {
//         const response = await fetch(UrlApi + "/proveedores/updateandpostproveedor", {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//                 accion: accion, // <--- INDISPENSABLE para que el backend sepa qué hacer
//                 datosFormulario: datosFormulario,

//                 imputaciones: (imputacionesSeleccionadas || []).map(imp => ({
//                     idimputacion: imp.idimputacion,
//                     nro_cuit: datosFormulario.nro_cuit,
//                     usuario: localStorage.getItem("user")
//                 })),

//                 empresas: (empresasSeleccionadas || []).map(id_empresa => ({
//                     id_empresa,
//                     nro_cuit: datosFormulario.nro_cuit,
//                     usuario: localStorage.getItem("user")
//                 })),

//                 // Agregamos operaciones para que el backend las procese en Acción 2
//                 operaciones: (operacionesSeleccionadas || []).map(op => ({
//                     id_operacion: op.id_operacion || op.idoperacion,
//                     nro_cuit: datosFormulario.nro_cuit,
//                     usuario: localStorage.getItem("user"),
//                     operacion_otros: op.operacion_otros
//                 }))
//             }),
//         });

//         const data = await response.json();

//         if (!response.ok) {
//             console.error("Error del servidor:", data);
//             return data; // Retornamos para manejar el error en el componente
//         }

//         return data;

//     } catch (error) {
//         console.error("Error en el fetch:", error);
//         return { ok: false, msg: "Error de conexión con el servidor" };
//     }
// };